module.exports = "## Floating Action Button\n\nThe [Floating Action Button](https://www.google.com/design/spec/components/buttons-floating-action-button.html)\nis used for frequently used functions.\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/FloatingActionButton/README.md
 ** module id = 988
 ** module chunks = 0
 **/